import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconSearch';
/** Renders an SVG icon. */
const SvgSearch = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M27.707 27.707a1 1 0 0 0 0-1.414l-6.109-6.109A10.46 10.46 0 0 0 24 13.5C24 7.701 19.299 3 13.5 3S3 7.701 3 13.5 7.701 24 13.5 24c2.54 0 4.868-.901 6.684-2.402l6.109 6.11a1 1 0 0 0 1.414 0ZM13.5 22a8.5 8.5 0 1 1 0-17 8.5 8.5 0 0 1 0 17"
      />
    </svg>
  );
};
SvgSearch.displayName = displayName;
export default SvgSearch;
